/**
 * @typedef {Object} MFASettings
 * @property {boolean} required
 * @property {Array} activate_mfa
 * @property {string} preferred_mfa
 * @property {boolean} device_remembered
 * @property {Date} device_remembered_on
 */

/**
 * @typedef {Object} MFASetup
 * @property {boolean} accessToken
 * @property {boolean} refreshToken
 * @property {boolean} idToken
 * @property {boolean} tokenType
 * @property {boolean} expiresIn
 */

/**
 * @typedef {Object} CognitoUser
 * @property {boolean} isLogged
 * @property {MFASettings} mfaSettings
 */

/**
 * @typedef {Object} CognitoChallenge
 * @property {string} name
 * @property {string} username
 * @property {string} password
 * @property {string} session
 * @property {string} deviceKey
 * @property {string} deviceGroupKey
 */

/**
 * @typedef {Object} CognitoState
 * @property {CognitoUser} user
 * @property {CognitoChallenge} challenge
 * @property {MFASetup} mfaSetup
 * @property {boolean} loading
 * @property {string} error
 */

/**
 * @typedef {Object} CognitoDispatch
 * @property {function} dispatch
 * @property {function} authenticate
 * @property {function} handleChangePasswordChallenge
 * @property {function} handleMFAChallenge
 * @property {function} getMFASettings
 * @property {function} updateMFASettings
 * @property {function} removeSoftwareToken
 * @property {function} setupMFATOTP
 * @property {function} setupEmailOTP
 * @property {function} resendMFACodeViaEmail
 * @property {function} switchMFAMethod
 * @property {function} requiresMFA
 * @property {function} logout
 * @property {function} setError
 * @property {function} resetChallenge
 * @property {function} promoteTemporarySession
 * @property {function} unsetRememberedDevice
 */

export const challengeTypes = Object.freeze({
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
  EMAIL_OTP: 'EMAIL_OTP',
  MFA_SETUP: 'MFA_SETUP',
})

export const mfaTypes = Object.freeze({
  softwareTokenMfa: 'SOFTWARE_TOKEN_MFA',
  emailTotp: 'EMAIL_OTP',
})

export {}
